<template>
  <base-page-layout title="Bloqueio">
    <block-document-import-modal v-model="openDialog" :imports-array="importsArray" @return-page="returnPage" />
    <v-card>
      <v-card-title class="pb-0">
        <h2 class="mb-0 section-title">Novo bloqueio</h2>
        <p class="subtitle text-style">
          Consumidores bloqueados, ainda podem efetuar compras nas lojas e receber descontos do clube. Porém eles não serão capazes de acumular pontos/cashback.
          Se algum consumidor bloqueado já possuia esse beneficio, ele não será capaz de utilizar enquanto permanecer no bloqueio. Você pode desbloquear
          CPFs/CNPJs a qualquer momento.
        </p>
      </v-card-title>
      <v-card-text>
        <v-row>
          <import-dynamic-csv
            v-model="openImportModal"
            title="Importados da lista"
            import-label="Importar lista de clientes"
            :required-any-of="importRequiredAnyOfFields"
            :fields="importFields"
            load-objects
          />
          <v-col v-if="fileName.length" class="py-0" cols="12">
            <p class="mb-0 px-0 file-name">{{ fileName }}</p>
          </v-col>
          <v-col class="pt-0" cols="12">
            <mf-button color="marca-0-l40" text label="Importar lista de CPFs/CNPJs" @click="openImportModal = true" />
          </v-col>
          <v-col class="py-0" cols="12">
            <h4 class="mb-0 mf-subtitle-2">Incluir CPFs/CNPJs</h4>
          </v-col>
          <v-col class="pb-0" cols="6">
            <v-text-field v-model="documentNo" v-mask="'###.###.###-##'" :label="labelText" :error-messages="errorMessage" outlined dense />
          </v-col>
          <v-col class="pb-0" cols="6">
            <mf-button outlined label="Adicionar" @click="addNewDocument" />
          </v-col>
          <v-col class="pt-0 mt-n3" cols="12">
            <v-chip-group :column="showAllDocuments" multiple>
              <v-chip v-for="(document, index) in documents" :key="document" close @click:close="removeDocument(index)">
                {{ document }}
              </v-chip>
            </v-chip-group>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <mf-action-buttons
      class="mt-2"
      :primary-button="{
        text: 'Salvar',
        action: saveBlockedUsers,
        isVisible: true,
        isLoading: loading,
      }"
      :extra-button="{
        text: 'Cancelar',
        action: returnPage,
        isVisible: true,
      }"
    />
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import ImportDynamicCsv from '@/components/ImportDynamicCsv.vue'
import BlockDocumentImportModal from './BlockDocumentImportModal.vue'
import { MUTATION_BLOCK_USERS_DISCOUTS } from '../graphql'

export default {
  name: 'BlockDocument',
  components: {
    BasePageLayout,
    ImportDynamicCsv,
    BlockDocumentImportModal,
  },
  provide: function () {
    return {
      objectSelected: this.getImportedDocuments,
      updateRequiredColumns: () => {},
    }
  },
  data: () => ({
    loading: false,
    openDialog: false,
    openImportModal: false,
    showAllDocuments: false,
    returnTab: 0,
    documentNo: '',
    errorMessage: '',
    fileName: '',
    returnName: '',
    importsArray: {
      alreadyBlocked: [],
      blockedNow: [],
      invalid: [],
    },
    documents: [],
    importedDocuments: [],
    importRequiredAnyOfFields: ['cpf_cnpj'],
    importFields: [{ text: 'CPF/CNPJ', value: 'cpf_cnpj' }],
  }),
  computed: {
    isPointsOrCashback() {
      return this.returnName === 'Cashback' ? 'cashback' : 'pontos'
    },
    labelText() {
      return `CPFs/CNPJs que deixam de poder acumular ${this.isPointsOrCashback}`
    },
  },
  mounted() {
    const {
      params: { returnName, tab },
    } = this.$route
    this.returnName = returnName || 'pontos'
    this.returnTab = tab
  },
  methods: {
    addNewDocument() {
      const isValidDocument = this.validateDocument(this.documentNo)
      const isIncludeInDocuments = this.documents.includes(this.documentNo)

      if (isValidDocument && !isIncludeInDocuments) {
        this.documents.push(this.documentNo)
        this.documentNo = ''
        this.errorMessage = ''
        return
      }

      this.errorMessage = 'CPF/CNPJ inválido'
    },
    validateDocument(document) {
      const regexCpf = /([0-9]{2}[.]?[0-9]{3}[.]?[0-9]{3}[/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[.]?[0-9]{3}[.]?[0-9]{3}[-]?[0-9]{2})/
      const isValidDocument = regexCpf.test(document)

      return isValidDocument
    },
    removeDocument(documentIndex) {
      this.documents.splice(documentIndex, 1)
    },
    getImportedDocuments(importFile) {
      const {
        fileName,
        objects: [, ...documents],
      } = importFile

      const filteredDocuments = documents.map((document) => document.cpf_cnpj)
      this.fileName = fileName
      this.importedDocuments = filteredDocuments

      this.$snackbar({ message: 'Lista de CPFs/CNPJs importada com sucesso.', snackbarColor: 'sucesso' })
    },
    saveBlockedUsers() {
      const allDocuments = this.documents.concat(this.importedDocuments)

      if (!allDocuments.length) {
        this.$snackbar({ message: 'Insira um CPF/CNPJ para continuar.', snackbarColor: 'error' })
        return
      }

      this.loading = true
      this.$apollo
        .mutate({
          mutation: MUTATION_BLOCK_USERS_DISCOUTS,
          variables: {
            documents_no: allDocuments,
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data: { blockUsersDiscounts } }) => {
          const { users_already_blocked, users_blocked_now, invalid_users } = blockUsersDiscounts

          this.importsArray.blockedNow = users_blocked_now
          this.importsArray.alreadyBlocked = users_already_blocked
          this.importsArray.invalid = invalid_users
          this.openDialog = true
          this.loading = false
        })
    },
    returnPage() {
      if (this.returnName === 'Cashback') {
        this.$router.push('/mobile/cashback/controle-de-cpf').catch(() => {})
      } else {
        this.$router.push({ name: 'pontos', query: { tab: this.returnTab || 2 } }).catch(() => {})
      }
    },
  },
}
</script>

<style lang="scss">
.text-style {
  word-break: normal;
  line-height: 21px;
}
.link-color {
  color: $marca-0-l40 !important;
}
.file-name {
  color: $cinza-d10 !important;
}
</style>
